import React from 'react';
import { faBuilding } from '@fortawesome/pro-regular-svg-icons/faBuilding';
import {
  ELEMENT_TYPE,
  type DocumentElement as DocumentElementType,
} from '@eaco/forms-core';
import EntityPicker from './EntityPicker';
import { ENTITY_KINDS, managedPropertySnapshot } from './entityKinds';
import { DOCUMENT_ELEMENT_MANAGED_PROPERTIES_QUERY } from './queries';

const ManagedPropertyPicker: React.FC<{ element: DocumentElementType }> = ({
  element,
}) => (
  <EntityPicker
    element={element}
    query={DOCUMENT_ELEMENT_MANAGED_PROPERTIES_QUERY}
    collectionField="documentElementManagedProperties"
    icon={faBuilding}
    iconColour="#2f6fdb"
    defaults={{
      label: 'Property',
      placeholder: 'Search for a property...',
    }}
    rowSubtitle={(row) =>
      (row.addressFormatted as string | null | undefined) || null
    }
    rowBadges={(row) => {
      const out: string[] = [];
      if (row.refId) out.push(`#${row.refId}`);
      if (row.customerName) out.push(String(row.customerName));
      return out;
    }}
    rowToSnapshot={managedPropertySnapshot}
    contextSpec={ENTITY_KINDS[ELEMENT_TYPE.managedProperty].contextSpec}
  />
);

export default ManagedPropertyPicker;
